import { render, staticRenderFns } from "./BrainExerciseDetail.vue?vue&type=template&id=f8b913ca"
import script from "./BrainExerciseDetail.vue?vue&type=script&lang=js"
export * from "./BrainExerciseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports